export const environment = {
  production: false,
  baseUrl: 'https://cci.devbyopeneyes.com',
  apiUrl: 'https://api.cci.devbyopeneyes.com',
  cookieDomainUrl: 'cci.devbyopeneyes.com',
  env: 'local',
  CAPTCHA_SITE_KEY: '6LfibjsrAAAAAF_WEH9LODomYZg2r2_XFjbsbWEU',
  showCaptcha: true,
  psiUrl: null,
  learnUponUrl: 'https://oeccitest.learnupon.com',
};
